import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.update()
    document.addEventListener("turbo:load", this.update)
    document.addEventListener("turbo:frame-load", this.update)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.update)
    document.removeEventListener("turbo:frame-load", this.update)
  }

  update = () => {
    const current = window.location.pathname
    // WALLETTODO: check if this is good solution for active link detection
    this.linkTargets.forEach(link => {
      const href = link.getAttribute("href")
      // Parse href to get only the pathname (remove query string and hash)
      const hrefPath = href ? href.split('?')[0].split('#')[0] : ''
      if (current === hrefPath || current.startsWith(hrefPath + "/")) {
        link.setAttribute("aria-current", "page")
      } else {
        link.removeAttribute("aria-current")
      }
    })
  }
}
